import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../../services/authentication/login.service';

@Component({
  selector: 'app-kpihome',
  templateUrl: './kpihome.component.html',
  styleUrls: ['./kpihome.component.css']
})
export class KpihomeComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
	      	{name:'Kpi Conductor', desc:'Efectividad por Conductor', icon:'fas fa-user-clock', url:'/kpidriver', perm: 'LOGI-ADMIN-KPI_DRIVER'},
	      	{name:'Kpi Cliente', desc:'Servicio al Cliente', icon:'fas fa-grin-stars', url:'/kpicustomer', perm: 'LOGI-ADMIN-KPI_CUST_SERV'},
	      	{name:'Kpi Delivery', desc:'Tiempo de Entrega', icon:'fas fa-clipboard-check', url:'/kpideliverytime', perm: 'LOGI-ADMIN-KPI_DELIVERY_TIME'},
	      	{name:'Kpi Stop', desc:'Tiempo de Parada en Ruta', icon:'fas fa-stopwatch', url:'/kpistoptime', perm: 'LOGI-ADMIN-KPI_STOP_TIME'}
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
